import { Action } from '@ngrx/store';
import { OneClickProfilesLoadState } from '../constants/one-click-table-profiles-state';
import { OneClickProfileDeleteState } from '../constants/one-click.-delete-profile-state';
import { OneClickOrderProfileResponse } from '@ordersnproducts/modules/one-click-order/models/one-click-order-profile-response';

export enum OneClickProfilesActionTypes {
  LOAD = '[OneClickProfiles] Load one click profiles',
  LOAD_SUCCESS = '[OneClickProfiles] Loaded one click profiles',
  LOAD_FAIL = '[OneClickProfiles] Failed loading one click profiles',
  DELETE = '[OneClickProfiles] Delete one click profiles',
  DELETED = '[OneClickProfiles] Deleted one click profiles',
  NOT_DELETED = '[OneClickProfiles] Not deleted one click profile',
  FILTER = '[OneClickProfiles] Start filtering one click profiles',
  FILTER_SUCCESS = '[OneClickProfiles] Success one click profiles filtered',
  FILTER_ERROR = '[OneClickProfiles] Failed filtering one click profiles',
  RESET_FILTER = '[OneClickProfiles] Reset filter one click profiles',
}
export class OneClickProfilesLoad implements Action {
  readonly type = OneClickProfilesActionTypes.LOAD;

  constructor(public payload: OneClickProfilesLoadState) {}
}

export class OneClickProfilesLoadSuccess implements Action {
  readonly type = OneClickProfilesActionTypes.LOAD_SUCCESS;

  constructor(public payload: OneClickOrderProfileResponse) {}
}

export class OneClickProfilesLoadFail implements Action {
  readonly type = OneClickProfilesActionTypes.LOAD_FAIL;

  constructor(public payload: any) {}
}

export class OneClickProfileDeleteAction implements Action {
  readonly type = OneClickProfilesActionTypes.DELETE;

  constructor(public payload: OneClickProfileDeleteState) {}
}

export class OneClickProfileDeletedAction implements Action {
  readonly type = OneClickProfilesActionTypes.DELETED;

  constructor(public payload: OneClickProfilesLoadState) {}
}

export class OneClickProfileNotDeletedAction implements Action {
  readonly type = OneClickProfilesActionTypes.NOT_DELETED;

  constructor(public payload: any) {}
}

export class OneClickProfilesFilter implements Action {
  readonly type = OneClickProfilesActionTypes.FILTER;

  constructor(public payload: OneClickProfilesLoadState) {}
}

export class OneClickProfilesFilterSuccess implements Action {
  readonly type = OneClickProfilesActionTypes.FILTER_SUCCESS;

  constructor(public payload: OneClickOrderProfileResponse) {}
}

export class OneClickProfilesFilterError implements Action {
  readonly type = OneClickProfilesActionTypes.FILTER_ERROR;

  constructor(public payload: any) {}
}

export class OneClickProfilesResetFilter implements Action {
  readonly type = OneClickProfilesActionTypes.RESET_FILTER;
}

export type OneClickProfilesActions =
  | OneClickProfilesLoad
  | OneClickProfilesLoadSuccess
  | OneClickProfilesLoadFail
  | OneClickProfileDeleteAction
  | OneClickProfileDeletedAction
  | OneClickProfileNotDeletedAction
  | OneClickProfilesFilter
  | OneClickProfilesFilterSuccess
  | OneClickProfilesFilterError
  | OneClickProfilesResetFilter;
